const translations = {
    subscriptionSuccessfullyUpdated: 'Subscription successfully updated'
};

export default translations;
